import { useWatch } from "react-hook-form";
import { DropdownInput } from "../DropdownInput";
import { SwitchInput } from "../SwitchInput";
import { TextInput } from "../TextInput";

const SAFETY_RATINGS = [
  { value: "satisfactory", label: "Satisfactory" },
  { value: "conditional", label: "Conditional" },
  { value: "unsatisfactory", label: "Unsatisfactory" },
  { value: "unrated", label: "Unrated" },
];

export function CorgiInsuredQuestions({ control, register }) {
  const carriers = useWatch({ control, name: "step2.carrier" }) || [];
  if (!carriers.includes("Corgi Trucking")) return null;

  return (
    <div className="rounded-lg border p-4 space-y-4">
      <h3 className="text-lg font-semibold">Corgi Trucking</h3>
      <TextInput
        register={register}
        label="Primary Contact Title"
        id="corgi-primary-contact-title"
        stepName="step2.primaryContactTitle"
        stepId="step2"
      />
      <DropdownInput
        control={control}
        label="DOT Safety Rating"
        dropdownLabel="Select DOT Safety Rating"
        stepName="step2.dotSafetyRating"
        stepId="step2"
        itemList={SAFETY_RATINGS}
      />
      <SwitchInput
        control={control}
        id="corgi-ownership-change"
        stepName="step2.ownershipChangeLast12Months"
        stepId="step2"
        label="Any ownership change in the last 12 months?"
      />
    </div>
  );
}
